import React from 'react';
import { render } from 'react-dom';
import App from './App';

function feedJobs() {
  const el = document.getElementById('jobs-app');

  if (el !== null) {
    const defaults = {
      perPage: 7,
    };

    const perPage = el.getAttribute('data-per-page');

    const settings = {
      perPage: perPage !== null ? parseFloat(perPage) : defaults.perPage,
    };

    render(<App {...settings} />, el);
  }
}
feedJobs();
